/**
 * Form Validation Utility
 * Replaces alert() dialogs with inline validation messages
 */

/**
 * Show an error message below a form field
 * @param {HTMLElement} inputElement - The input element to show error for
 * @param {string} message - Error message to display
 */
export function showFieldError(inputElement, message) {
  // Remove any existing error first
  removeFieldError(inputElement);

  const error = document.createElement('div');
  error.className = 'field-error';
  error.textContent = message;

  inputElement.classList.add('error');

  // Insert after the input element
  if (inputElement.nextSibling) {
    inputElement.parentElement.insertBefore(error, inputElement.nextSibling);
  } else {
    inputElement.parentElement.appendChild(error);
  }

  inputElement.focus();
}

/**
 * Remove error message from a form field
 * @param {HTMLElement} inputElement - The input element to clear error from
 */
export function removeFieldError(inputElement) {
  inputElement.classList.remove('error');

  // Remove error message (could be next sibling or anywhere in parent)
  const parent = inputElement.parentElement;
  const existingError = parent.querySelector('.field-error');
  if (existingError) {
    existingError.remove();
  }
}

/**
 * Clear errors when user starts typing
 * @param {HTMLElement} inputElement - The input element to attach listener to
 */
export function clearErrorOnInput(inputElement) {
  inputElement.addEventListener('input', () => removeFieldError(inputElement), { once: true });
}
